import { FORMER_FIRM_MESSAGE, isFormerFirm } from '@grc/shared';
import type { ReactNode } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import type { Loadable } from '../api';
import { PageHeader } from '../components';
import type { Me } from '../types';

export function FormerFirmPage() {
  return <PageHeader title={FORMER_FIRM_MESSAGE} />;
}

/** National, the Board, and a member of a former firm see the sentence instead of that firm's pages. */
export function FormerFirmGate({ children }: { children: ReactNode }) {
  const { firmCode = '' } = useParams();
  const me = useOutletContext<Loadable<Me>>();
  if (!isFormerFirm(firmCode)) return children;
  if (me.loading || !me.data) return null;
  const code = firmCode.toUpperCase();
  const allowed = me.data.tiers.national || me.data.tiers.board || (me.data.formerFirms ?? []).includes(code);
  return allowed ? <FormerFirmPage /> : children;
}
